import { type FieldValues, type Path } from "react-hook-form";
import { FormFieldSeparator } from "@/components/site-builder/modules/CustomFormModule/constants";
import { type FormBuilderFieldCode } from "@/constants/form-builder";
import { type FormBuilderItem } from "@/types/form-builder";

export function transformCustomFormValues<T extends FieldValues>(
  formValues: Record<Path<T>, unknown>,
): FormBuilderItem[] {
  const items: FormBuilderItem[] = [];

  Object.entries(formValues).forEach(([fieldName, fieldValue]) => {
    const isMultipleValue = Array.isArray(fieldValue);

    const [id, fieldCode] = fieldName.split(FormFieldSeparator);
    const isWrongName = !id || !fieldCode;

    if (isWrongName) return;

    const code = fieldCode as FormBuilderFieldCode;
    const values = isMultipleValue
      ? fieldValue.map(String)
      : [String(fieldValue)];

    items.push({
      id,
      code,
      values: values.filter(Boolean),
    });
  });

  return items;
}
